import { createFeatureSelector, createSelector } from '@ngrx/store';
import { BookWidgetStoreKey } from '../../constants/common.constants';
import { BookWidgetStore } from '../../models/states/book-widget-store.interfaces';

const bookWidgetStoreFeatureSelector =
  createFeatureSelector<BookWidgetStore>(BookWidgetStoreKey);

const getGeoLocationState = createSelector(
  bookWidgetStoreFeatureSelector,
  (state) => state.geoLocation
);

export const shouldTriggerGeoLocationApi = createSelector(
  getGeoLocationState,
  ({ skipGeoLocationApi, isReady }) => !skipGeoLocationApi && !isReady
);

export const isGeoLocationStateReady = createSelector(
  getGeoLocationState,
  ({ isReady, skipGeoLocationApi, isError }) =>
    skipGeoLocationApi || isReady || isError
);

export const getGeoLocationData = createSelector(
  getGeoLocationState,
  ({ geoLocationData }) => geoLocationData
);
